import { render, staticRenderFns } from "./ReconocimientosSection.vue?vue&type=template&id=574db221&scoped=true"
import script from "./ReconocimientosSection.vue?vue&type=script&lang=js"
export * from "./ReconocimientosSection.vue?vue&type=script&lang=js"
import style0 from "./ReconocimientosSection.vue?vue&type=style&index=0&id=574db221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574db221",
  null
  
)

export default component.exports